var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-app-bar",
        {
          staticStyle: { "border-bottom": "1px solid grey !important" },
          attrs: { app: "", elevation: "0" },
        },
        [
          _c("v-app-bar-nav-icon", {
            attrs: { disabled: !_vm.isUserLoggedIn },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                _vm.drawer = !_vm.drawer
              },
            },
          }),
          _c(
            "span",
            {
              staticClass: "text--secondary text-h6 d-none d-sm-flex",
              staticStyle: { cursor: "pointer" },
              on: { click: _vm.goHome },
            },
            [_vm._v(" Consumer Application Self Service ")]
          ),
          _c(
            "span",
            { staticClass: "text--secondary text-h6 d-flex d-sm-none" },
            [_vm._v(" CASS ")]
          ),
          _c("v-spacer"),
          _vm.isUserLoggedIn ? _c("theme-button") : _vm._e(),
          _vm.isUserLoggedIn && _vm.isUserAdmin
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      icon: "",
                                      loading: _vm.maintenanceLoading,
                                      color: _vm.maintenanceEnabled
                                        ? "red"
                                        : "#646464",
                                    },
                                    on: { click: _vm.openMaintenanceDialog },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [_c("v-icon", [_vm._v("mdi-alert-octagon")])],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4214768721
                  ),
                },
                [_c("span", [_vm._v("UI Maintenance Mode")])]
              )
            : _vm._e(),
          !_vm.isUserLoggedIn
            ? _c(
                "v-btn",
                {
                  staticClass: "mr-1",
                  attrs: {
                    icon: "",
                    disabled: !_vm.isUserLoggedIn,
                    color: "#646464",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.SignIn()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-login")])],
                1
              )
            : _vm._e(),
          _vm.isUserLoggedIn && _vm.userInfo
            ? _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "div",
                              [
                                _vm.isUserAdmin
                                  ? _c(
                                      "v-badge",
                                      {
                                        attrs: {
                                          color: "red",
                                          icon: "mdi-star",
                                          "offset-x": "25px",
                                          "offset-y": "25px",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-avatar",
                                          _vm._g(
                                            _vm._b(
                                              { staticClass: "mr-3" },
                                              "v-list-item-avatar",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm.userPhoto
                                              ? _c("img", {
                                                  attrs: { src: _vm.userPhoto },
                                                })
                                              : _vm._e(),
                                            !_vm.userPhoto
                                              ? _c(
                                                  "v-avatar",
                                                  {
                                                    attrs: {
                                                      color: "#006C27",
                                                      size: "40",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "white--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.nameinitials
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.isUserAdmin
                                  ? _c(
                                      "v-list-item-avatar",
                                      _vm._g(
                                        _vm._b(
                                          { staticClass: "mr-3" },
                                          "v-list-item-avatar",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _vm.userPhoto
                                          ? _c("img", {
                                              attrs: { src: _vm.userPhoto },
                                            })
                                          : _vm._e(),
                                        !_vm.userPhoto
                                          ? _c(
                                              "v-avatar",
                                              {
                                                attrs: {
                                                  color: "#006C27",
                                                  size: "40",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "white--text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.nameinitials)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4019969148
                  ),
                  model: {
                    value: _vm.menu,
                    callback: function ($$v) {
                      _vm.menu = $$v
                    },
                    expression: "menu",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-list",
                        [
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-icon",
                                [_c("v-icon", [_vm._v("mdi-account-outline")])],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      _vm._s(_vm.userInfo.givenName) +
                                        " " +
                                        _vm._s(_vm.userInfo.surname)
                                    ),
                                  ]),
                                  _c("v-list-item-subtitle", [
                                    _c("div", [
                                      _vm._v(_vm._s(_vm.userInfo.jobTitle)),
                                    ]),
                                    _vm.isUserAdmin
                                      ? _c(
                                          "div",
                                          {
                                            style: _vm.isUserAdmin
                                              ? "color: red; cursor: pointer"
                                              : "cursor: pointer",
                                            on: { click: _vm.toogleAdmin },
                                          },
                                          [_vm._v(" CASS Administrator ")]
                                        )
                                      : _vm._e(),
                                    !_vm.isUserAdmin
                                      ? _c("div", [_vm._v("CASS User")])
                                      : _vm._e(),
                                    _vm.isBetaUser
                                      ? _c("div", [_vm._v("Beta User")])
                                      : _vm._e(),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-icon",
                                [_c("v-icon", [_vm._v("mdi-star-outline")])],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                { staticClass: "mt-1" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Active Environments"),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _vm._l(
                                        _vm.userEnvironments,
                                        function (env, index) {
                                          return [
                                            _c("div", { key: index }, [
                                              _vm._v(_vm._s(env)),
                                            ]),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.userDiagnostics
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-information-outline"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    { staticClass: "mt-1" },
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Auth Diagnostics"),
                                      ]),
                                      _c(
                                        "v-list-item-subtitle",
                                        [
                                          _vm.isExternalDiagnosticsUser
                                            ? [
                                                _c("div", [
                                                  _vm._v(
                                                    "User Type: " +
                                                      _vm._s(
                                                        _vm.userDiagnostics
                                                          .userType || "-"
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    " Auth Checked: " +
                                                      _vm._s(
                                                        _vm.userDiagnostics
                                                          .authCheckedAt
                                                          ? _vm.formatDiagnosticsTime(
                                                              _vm
                                                                .userDiagnostics
                                                                .authCheckedAt
                                                            )
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    " Roles Checked: " +
                                                      _vm._s(
                                                        _vm.userDiagnostics
                                                          .rolesCheckedAt
                                                          ? _vm.formatDiagnosticsTime(
                                                              _vm
                                                                .userDiagnostics
                                                                .rolesCheckedAt
                                                            )
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _vm._v(
                                                    " Owner Ref: " +
                                                      _vm._s(
                                                        _vm.userDiagnostics
                                                          .projection &&
                                                          _vm.userDiagnostics
                                                            .projection.ownerRef
                                                          ? _vm.userDiagnostics
                                                              .projection
                                                              .ownerRef
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ]),
                                              ]
                                            : [
                                                _c("div", [
                                                  _vm._v(
                                                    "Source: " +
                                                      _vm._s(
                                                        _vm.userDiagnostics
                                                          .authSource
                                                      )
                                                  ),
                                                ]),
                                                _vm.userDiagnostics.userType
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " User Type: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .userType
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                !_vm.isApplicationLimitMissing
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " App Limit: " +
                                                          _vm._s(
                                                            _vm.diagnosticsApplicationLimit
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "red--text text--darken-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " App Limit: MISSING "
                                                        ),
                                                      ]
                                                    ),
                                                !_vm.isCertificateLimitMissing
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Cert Limit: " +
                                                          _vm._s(
                                                            _vm.diagnosticsCertificateLimit
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "red--text text--darken-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Cert Limit: MISSING "
                                                        ),
                                                      ]
                                                    ),
                                                typeof _vm.userDiagnostics
                                                  .isGrantedForInternalAPIs ===
                                                "boolean"
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Internal API Access: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .isGrantedForInternalAPIs
                                                              ? "yes"
                                                              : "no"
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .decisionReasonCode
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Reason: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .decisionReasonCode
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .authCheckedAt
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Auth Checked: " +
                                                          _vm._s(
                                                            _vm.formatDiagnosticsTime(
                                                              _vm
                                                                .userDiagnostics
                                                                .authCheckedAt
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .rolesCheckedAt
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Roles Checked: " +
                                                          _vm._s(
                                                            _vm.formatDiagnosticsTime(
                                                              _vm
                                                                .userDiagnostics
                                                                .rolesCheckedAt
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics.projection
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Owner Ref: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection
                                                              .ownerRef || "-"
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                _vm.userDiagnostics.projection
                                                  .ownerType
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Owner Type: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection
                                                              .ownerType
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                _vm.userDiagnostics.projection
                                                  .ext14
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Ext14: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection.ext14
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                _vm.userDiagnostics.projection
                                                  .email
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Projection Email: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection.email
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                _vm.userDiagnostics.projection
                                                  .displayName
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Projection Name: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection
                                                              .displayName
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                typeof _vm.userDiagnostics
                                                  .projection.isUnresolved ===
                                                  "boolean"
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Projection Unresolved: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection
                                                              .isUnresolved
                                                              ? "yes"
                                                              : "no"
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                _vm.userDiagnostics.projection
                                                  .unresolvedReasonCode
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Projection Reason: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection
                                                              .unresolvedReasonCode
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                typeof _vm.userDiagnostics
                                                  .projection.isAmbiguous ===
                                                  "boolean"
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Projection Ambiguous: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection
                                                              .isAmbiguous
                                                              ? "yes"
                                                              : "no"
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                _vm.userDiagnostics.projection
                                                  .isAmbiguous === true &&
                                                _vm.userDiagnostics.projection
                                                  .candidateCount
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Projection Candidate Count: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection
                                                              .candidateCount
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                _vm.userDiagnostics.projection
                                                  .isAmbiguous === true &&
                                                _vm.userDiagnostics.projection
                                                  .primarySelectionReason
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " Projection Selection: " +
                                                          _vm._s(
                                                            _vm.userDiagnostics
                                                              .projection
                                                              .primarySelectionReason
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm.userDiagnostics
                                                  .projection &&
                                                _vm.userDiagnostics.projection
                                                  .isAmbiguous === true &&
                                                _vm.ambiguityAlternateLines(
                                                  _vm.userDiagnostics.projection
                                                ).length > 0
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c("div", [
                                                          _vm._v(
                                                            "Projection Alternates:"
                                                          ),
                                                        ]),
                                                        _vm._l(
                                                          _vm.ambiguityAlternateLines(
                                                            _vm.userDiagnostics
                                                              .projection
                                                          ),
                                                          function (
                                                            line,
                                                            lineIndex
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key:
                                                                  "profile-ambiguity-line-" +
                                                                  lineIndex,
                                                                staticClass:
                                                                  "profile-ambiguity-line",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      line
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                              ],
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-list-item-group",
                            [
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.logout()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [_c("v-icon", [_vm._v("mdi-logout")])],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Logout"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c("v-img", {
                staticClass: "shrink mr-2",
                attrs: {
                  alt: "Schaeffler Logo",
                  contain: "",
                  src: _vm.$getImagePath("schaeffler-logo.svg"),
                  transition: "scale-transition",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          attrs: { fixed: "", temporary: "", width: 325 },
          model: {
            value: _vm.drawer,
            callback: function ($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer",
          },
        },
        [
          _c(
            "v-list",
            { attrs: { nav: "", dense: "" } },
            [
              _c(
                "v-list-item-group",
                [
                  _c(
                    "v-list-item",
                    { on: { click: _vm.home } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "#006c27" } }, [
                            _vm._v("mdi-home-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-title",
                        { staticClass: "subtitle-1 text--secondary" },
                        [_vm._v("Home")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    { on: { click: _vm.apiportal } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "#006c27" } }, [
                            _vm._v("mdi-api"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-title",
                        { staticClass: "subtitle-1 text--secondary" },
                        [_vm._v("API Portal")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    { on: { click: _vm.developerportal } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "#006c27" } }, [
                            _vm._v("mdi-code-tags"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-title",
                        { staticClass: "subtitle-1 text--secondary" },
                        [_vm._v("Developer Portal")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    { on: { click: _vm.permissionModel } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "#006c27" } }, [
                            _vm._v("mdi-key-chain"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-title",
                        { staticClass: "subtitle-1 text--secondary" },
                        [_vm._v("Permission Models")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    { on: { click: _vm.environments } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "#006c27" } }, [
                            _vm._v("mdi-numeric-3-box-multiple-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-title",
                        { staticClass: "subtitle-1 text--secondary" },
                        [_vm._v("Environments")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    { on: { click: _vm.feedback } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "#006c27" } }, [
                            _vm._v("mdi-comment-quote-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-title",
                        { staticClass: "subtitle-1 text--secondary" },
                        [_vm._v("Feedback")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    { on: { click: _vm.mtlsaccount } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "#006c27" } }, [
                            _vm._v("mdi-certificate-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-title",
                        { staticClass: "subtitle-1 text--secondary" },
                        [_vm._v("Non-CASS Apps ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-list-item",
                    { on: { click: _vm.openpermissionrequest } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "#006c27" } }, [
                            _vm._v("mdi-account-key"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-title",
                        { staticClass: "subtitle-1 text--secondary" },
                        [_vm._v("Open Permission Requests ")]
                      ),
                    ],
                    1
                  ),
                  _vm.isUserAdmin
                    ? _c(
                        "v-list-item",
                        { on: { click: _vm.opendeletedapps } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "red" } }, [
                                _vm._v("mdi-delete-outline"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-title",
                            { staticClass: "subtitle-1 text--secondary" },
                            [_vm._v("Deleted Apps ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-list-item",
                    { on: { click: _vm.community } },
                    [
                      _c(
                        "v-list-item-icon",
                        [
                          _c("v-icon", { attrs: { color: "#006c27" } }, [
                            _vm._v("mdi-account-group-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-title",
                        { staticClass: "subtitle-1 text--secondary" },
                        [_vm._v("Community")]
                      ),
                    ],
                    1
                  ),
                  _vm.isUserAdmin
                    ? _c(
                        "v-list-item",
                        { on: { click: _vm.manage } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "#006c27" } }, [
                                _vm._v("mdi-cog-outline"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-title",
                            { staticClass: "subtitle-1 text--secondary" },
                            [_vm._v("Manage")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isUserAdmin
                    ? _c(
                        "v-list-item",
                        { on: { click: _vm.resolverDiagnostics } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "#006c27" } }, [
                                _vm._v("mdi-database-search-outline"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-title",
                            { staticClass: "subtitle-1 text--secondary" },
                            [_vm._v("Resolver Diagnostics")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isUserAdmin
                    ? _c(
                        "v-list-item",
                        { on: { click: _vm.sapAPIDiagnostics } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "#006c27" } }, [
                                _vm._v("mdi-heart-pulse"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-title",
                            { staticClass: "subtitle-1 text--secondary" },
                            [_vm._v(" SAPAPI Diagnostics ")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isUserAdmin
                    ? _c(
                        "v-list-item",
                        { on: { click: _vm.backgroundJobs } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "#006c27" } }, [
                                _vm._v("mdi-timer-cog-outline"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-title",
                            { staticClass: "subtitle-1 text--secondary" },
                            [_vm._v("Background Jobs")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isUserAdmin
                    ? _c(
                        "v-list-item",
                        { on: { click: _vm.authFailures } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "#006c27" } }, [
                                _vm._v("mdi-shield-alert-outline"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-title",
                            { staticClass: "subtitle-1 text--secondary" },
                            [_vm._v("Auth Failures")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isUserAdmin
                    ? _c(
                        "v-list-item",
                        { on: { click: _vm.creationDiagnostics } },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", { attrs: { color: "#006c27" } }, [
                                _vm._v("mdi-clipboard-pulse-outline"),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-title",
                            { staticClass: "subtitle-1 text--secondary" },
                            [_vm._v("Creation Diagnostics")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "700" },
          model: {
            value: _vm.maintenanceDialog,
            callback: function ($$v) {
              _vm.maintenanceDialog = $$v
            },
            expression: "maintenanceDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text--secondary" }, [
                _vm._v(" UI Maintenance Mode Control "),
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        dense: "",
                        outlined: "",
                        type: "error",
                        border: "left",
                        "colored-border": "",
                      },
                    },
                    [
                      _c("strong", [_vm._v("Warning:")]),
                      _vm._v(
                        " Activating maintenance mode immediately blocks all non-admin users from every protected API endpoint. Existing non-admin sessions are interrupted and redirected to the maintenance screen on their next request. "
                      ),
                    ]
                  ),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        dense: "",
                        outlined: "",
                        type: "warning",
                        border: "left",
                        "colored-border": "",
                      },
                    },
                    [
                      _vm._v(
                        " Proceed only when planned maintenance is confirmed and stakeholder communication is complete. "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex align-center mt-2" },
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: _vm.maintenanceEnabled
                              ? "#b71c1c"
                              : "#006c27",
                            dark: "",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.maintenanceEnabled ? "ACTIVE" : "INACTIVE"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "ml-3",
                          staticStyle: { "font-size": "0.82rem" },
                        },
                        [
                          _vm._v(
                            " Last update: " +
                              _vm._s(_vm.maintenanceUpdatedAt || "-") +
                              " "
                          ),
                          _vm.maintenanceUpdatedBy
                            ? _c("span", [
                                _vm._v(
                                  " by " + _vm._s(_vm.maintenanceUpdatedBy)
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  !_vm.maintenanceEnabled
                    ? _c("v-checkbox", {
                        staticClass: "mt-4",
                        attrs: {
                          disabled: _vm.maintenanceLoading,
                          color: "#b71c1c",
                          label:
                            "I understand this will block all non-admin users immediately.",
                        },
                        model: {
                          value: _vm.maintenanceActivationConfirmed,
                          callback: function ($$v) {
                            _vm.maintenanceActivationConfirmed = $$v
                          },
                          expression: "maintenanceActivationConfirmed",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.maintenanceLoading },
                      on: {
                        click: function ($event) {
                          _vm.maintenanceDialog = false
                        },
                      },
                    },
                    [_vm._v(" Close ")]
                  ),
                  !_vm.maintenanceEnabled
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "#b71c1c",
                            dark: "",
                            loading: _vm.maintenanceLoading,
                            disabled:
                              _vm.maintenanceLoading ||
                              !_vm.maintenanceActivationConfirmed,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setMaintenanceMode(true)
                            },
                          },
                        },
                        [_vm._v(" Activate Maintenance ")]
                      )
                    : _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "#006c27",
                            dark: "",
                            loading: _vm.maintenanceLoading,
                            disabled: _vm.maintenanceLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setMaintenanceMode(false)
                            },
                          },
                        },
                        [_vm._v(" Deactivate Maintenance ")]
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }